var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./DoorConfiguration.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4ee6dfab!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DoorConfiguration.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Company/DoorConfiguration.vue
// module id = 592
// module chunks = 0